<script setup lang="ts">
import { ElTag } from 'element-plus'

import type { TagType } from './types'

/**
 * A short coloured label — a count, a format, a category. A record's **state** is
 * `StatusTag`, which takes the value and the two maps that turn it into a word and a
 * colour; do not map a status onto this one by hand.
 */
defineProps<{
  type?: TagType
  size?: 'large' | 'default' | 'small'
  effect?: 'dark' | 'light' | 'plain'
  closable?: boolean
  round?: boolean
  disabled?: boolean
  hit?: boolean
  color?: string
  /** Let a long label break onto several lines instead of overflowing its column. */
  wrap?: boolean
}>()

const emit = defineEmits<{
  (e: 'close', event: MouseEvent): void
}>()
</script>

<template>
  <ElTag
    :class="{ 'shared-tag--wrap': wrap }"
    :type="type"
    :size="size"
    :effect="effect"
    :closable="closable"
    :round="round"
    :disabled="disabled"
    :hit="hit"
    :color="color"
    v-bind="$attrs"
    @close="emit('close', $event)"
  >
    <slot />
  </ElTag>
</template>

<style lang="scss" scoped>
.shared-tag--wrap {
  height: auto;
  min-height: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 1.3;
  text-align: center;
  white-space: normal;
}
</style>
